// See:
// - https://github.com/remix-run/react-router/discussions/9851
// - https://github.com/kentcdodds/kentcdodds.com/blob/a427fa7a9cad53667916bdc86c1a607d0db5387e/app/utils/misc.tsx#L299
export const updateQueryStringValueWithoutNavigation = (
  queryKey: string,
  queryValue: string | undefined,
): void => {
  const currentSearchParams = new URLSearchParams(window.location.search);
  const oldQuery = currentSearchParams.get(queryKey) ?? '';
  if (queryValue === oldQuery) {
    return;
  }

  if (queryValue) {
    currentSearchParams.set(queryKey, queryValue);
  } else {
    currentSearchParams.delete(queryKey);
  }
  const newUrl = [window.location.pathname, currentSearchParams.toString()]
    .filter(Boolean)
    .join('?');

  // Alright, let's talk about this... Normally with remix, you'd update the
  // params via useSearchParams from react-router-dom and updating the search
  // params will trigger the search to update for you. However, it also triggers
  // a navigation to the new url, which will trigger the loader to run which we
  // do not want because all our data is already on the client and we're just
  // doing client-side filtering of data we already have. So we manually call
  // `window.history.pushState` to avoid the router from triggering the loader.
  window.history.replaceState(null, '', newUrl);
};
